export function getGeogroupingSlugFromPath(path = '') {
  if (!path) {
    return '';
  }

  return path.replace(/^\/l\//, '');
}
